export default __webpack_public_path__ + "static/media/conduitEdit1.2ba34096.jpg";